<template lang="pug">
    div.search-control
        div.search-control__icon
            svg-icon(iconId="search")
        input(:placeholder="placeholder" v-model="searchText" @focus="onFocus" @blur="onBlur" ref="inputEl")
</template>

<script>
import _ from 'underscore'

export default {
    name: 'search-control',
    props: {
        value: {
            type: String,
        },
        placeholder: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            searchText: '',
        }
    },
    watch: {
        value: {
            handler(val) {
                this.searchText = val
            },
            immediate: true,
        },
        searchText() {
            this.emitInputDebounce()
        },
    },
    methods: {
        focus() {
            this.$refs.inputEl.focus()
        },
        onFocus() {
            this.$emit('focus')
        },
        onBlur() {
            this.$emit('blur')
        },
        emitInput() {
            this.$emit('input', this.searchText)
        },
    },
    created() {
        this.emitInputDebounce = _.debounce(this.emitInput, 500)
    },
}
</script>